/* eslint-disable prettier/prettier */
import * as React from "react"
import { Widget, mk_widget, any } from "widgets-for-react"
import { styleguideChapter, styleguideSection, styleguidePart, styleguideExample } from "../helpers.mod"
import { FormElement } from "../../components/public_site/utils/forms"
import { expandBlock } from "../../components/drupal/drupal_to_cms.mod"
import { Pagination } from "../../components/public_site/templates/pagination.mod"
import { currentPage } from "../main.mod"
import { page } from "../../components/public_site/templates/drupal_page.mod"
import { pagination } from '../fake_data/pagination'
import { filterCheckboxesList } from "../fake_data/filtersOverlay"
import { linkBackAnchor, linkBackButton } from "../fake_data/links"

export const styleguideObjects: Widget<never> = mk_widget({
  run: _ => (
    styleguideChapter({ type: 'objects', slug: 'objects', title: 'Design Objects', intro: 'If design tokens are the atoms of the design system, design objects are the material — specifically, they what comes after. We use them to make the developer’s job easier and to give the designers some extra insight in their work.' })(
      any()([
        styleguideSection({ type: 'objects', slug: 'objects-filters', title: 'Filters', intro: '' })(
          styleguidePart({ title: 'Titles', intro: '' })(
            styleguideExample({ showExampleLabel: false, isFullScreen: false })(
              mk_widget({
                run: _ => (filterCheckboxesList())
              })
            )
          ),
        ),
        styleguideSection({ type: 'objects', slug: 'objects-typography', title: 'Typography', intro: '' })(
          any()([
            styleguidePart({ title: 'Titles', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                mk_widget({
                  run: _ => (
                    <>
                      <h1 className="title--xl">Title of homepage's header - XL</h1><br /><br />
                      <h1 className="title--l">Title of genaral pages header - L</h1><br /><br />
                      <h2 className="title--m">Integer posuere a ante venenatis - M</h2><br /><br />
                      <h3 className="title--s">Integer posuere erat a ante venenatis - S</h3><br />
                      <h4 className="title--xs">Integer posuere erat a ante venenatis - XS</h4>
                    </>
                  )
                })
              )
            ),
            styleguidePart({ title: 'Texts', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                mk_widget({
                  run: _ => (
                    <>
                      <p className="text--l">Integer posuere erat a ante venenatis aliquet. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. - L</p><br />
                      <p className="text--m">Integer posuere erat a ante venenatis aliquet. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. - M</p><br />
                      <p className="text--s">Integer posuere erat a ante venenatis aliquet. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. - S</p><br />
                    </>
                  )
                })
              )
            ),
            styleguidePart({ title: 'Labels', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                mk_widget({
                  run: _ => (
                    <>
                      <p className="label--m">Integer posuere erat a ante venenatis aliquet - M</p>
                    </>
                  )
                })
              )
            ),
          ])
        ),
        styleguideSection({ type: 'objects', slug: 'objects-buttons', title: 'Buttons', intro: '' })(
          any()([
            styleguidePart({ title: 'Primary button', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                mk_widget({
                  run: _ => (
                    <>
                      <button className="button button--primary">Lorem ipsum</button>
                      <br />
                      <br />
                      <a href="" className="button button--primary">Lorem ipsum</a>
                      <br />
                      <br />
                      <button className="button button--primary" disabled>Lorem ipsum disabled</button>
                    </>
                  )
                })
              )
            ),
            styleguidePart({ title: 'Primary button on colored background', intro: '', extraClasses: ' styleguide__part--dark' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                mk_widget({
                  run: _ => (
                    <>
                      <button className="button button--primary--inverted">Lorem ipsum</button>
                      <br />
                      <br />
                      <a href="" className="button button--primary--inverted">Lorem ipsum</a>
                      <br />
                      <br />
                      <button className="button button--primary--inverted" disabled>Lorem ipsum disabled</button>
                    </>
                  )
                })
              )
            ),
            styleguidePart({ title: 'CookiePro button', intro: '', extraClasses: ' styleguide__part--dark' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                mk_widget({
                  run: _ => (
                    <>
                      <button id="ot-sdk-btn" className="button button--primary--inverted">Cookie-instellingen</button>
                    </>
                  )
                })
              )
            )
          ])
        ),
        styleguideSection({ type: 'objects', slug: 'objects-links', title: 'Links', intro: '' })(
          any()([
            styleguidePart({ title: 'Inline link', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                mk_widget({
                  run: _ => (
                    <div className="text--styled">
                      <p>Integer posuere erat a ante venenatis <a href="#">donec ullamcorper nulla</a> aliquet. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Donec id elit non mi porta gravida at eget metus.</p>
                    </div>
                  )
                })
              )
            ),
            styleguidePart({ title: 'Primary links', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                mk_widget({
                  run: _ => (
                    <>
                      <button className="link link--primary">Lorem ipsum</button>
                      <br />
                      <br />
                      <a href="" className="link link--primary">Lorem ipsum</a>
                    </>
                  )
                })
              )
            ),
            styleguidePart({ title: 'Secondary links', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                mk_widget({
                  run: _ => (
                    <>
                      <button className="link link--secondary">Lorem ipsum</button>
                      <br />
                      <br />
                      <a href="" className="link link--secondary">Lorem ipsum</a>
                    </>
                  )
                })
              )
            ),
            styleguidePart({ title: 'Link with arrow', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                mk_widget({
                  run: _ => (
                    <>
                      <button className="link link--arrow">Lorem ipsum</button>
                      <br />
                      <br />
                      <a href="" className="link link--arrow">Lorem ipsum</a>
                    </>
                  )
                })
              )
            ),
            styleguidePart({ title: 'Link to go back', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                mk_widget({
                  run: _ => (
                    <>
                      {linkBackButton()}
                      <br />
                      {linkBackAnchor()}
                    </>
                  )
                })
              )
            ),
            styleguidePart({ title: 'Links list with arrow', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                mk_widget({
                  run: _ => (
                    <ul className="list list--arrow">
                      <li>
                        <a href="" className="link">Lorem ipsum</a>
                      </li>
                      <li>
                        <a href="" className="link">Lorem ipsum</a>
                      </li>
                      <li>
                        <a href="" className="link">Lorem ipsum</a>
                      </li>
                    </ul>
                  )
                })
              )
            ),
          ])
        ),
        styleguideSection({ type: 'objects', slug: 'objects-lists', title: 'Lists', intro: '' })(
          any()([
            styleguidePart({ title: 'Ordered list (WYSIWYG)', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                mk_widget({
                  run: _ => (
                    <div className="text--styled">
                      <ol>
                        <li>Morbi leo risus, <a>porta ac consectetur ac</a>, vestibulum at eros.</li>
                        <li>Aenean lacinia bibendum nulla sed consectetur.</li>
                        <li>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.
                          <ol>
                            <li>Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</li>
                            <li>Aenean lacinia bibendum nulla sed consectetur.</li>
                          </ol>
                        </li>
                        <li>Nullam quis risus eget urna mollis ornare vel eu leo.</li>
                      </ol>
                    </div>
                  )
                })
              )
            ),
            styleguidePart({ title: 'Unorderd list (WYSIWYG)', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                mk_widget({
                  run: _ => (
                    <div className="text--styled">
                      <ul>
                        <li>Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</li>
                        <li>Aenean lacinia bibendum nulla sed consectetur.</li>
                        <li>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.
                          <ul>
                            <li>Integer consequat sapien a lectus gravida euismod.</li>
                            <li>Integer consequat sapien a lectus gravida euismod.</li>
                          </ul>
                        </li>
                        <li>Nullam quis risus eget urna mollis ornare vel eu leo.</li>
                      </ul>
                    </div>
                  )
                })
              )
            ),
            styleguidePart({ title: 'Expander', intro: '' })(
              styleguideExample({ showExampleLabel: false, isFullScreen: false })(
                mk_widget({
                  run: _ => (
                    <div className="blocklist__item">
                      <button className="blocklist__link" aria-label="Toggle item">
                        <p className="blocklist__title">Cras Ipsum Fermentum Lorem</p>
                      </button>
                      <br />
                      <br />
                      <button className="blocklist__link blocklist__link--active" aria-label="Toggle item">
                        <p className="blocklist__title">Cras Ipsum Fermentum Lorem</p>
                      </button>
                    </div>
                  )
                })
              )
            ),
          ])
        ),
        styleguideSection({ type: 'objects', slug: 'objects-pagination', title: 'Lists', intro: '' })(
          styleguidePart({ title: 'Pagination', intro: '' })(
            styleguideExample({ showExampleLabel: false, isFullScreen: false })(
              mk_widget({
                run: (_) => (pagination())
              })
            )
          )
        )
      ])
    ).run(_)
  )
})
